module.exports = __webpack_public_path__ + "assets/img/th-c30b6afb.png";